const resourceAlerts = document.querySelectorAll('.resource-alert');

resourceAlerts.forEach((alertBar) => {
    const closeButton = alertBar.querySelector('.resource-alert__close');

    if (!closeButton) {
        return;
    }

    closeButton.addEventListener('click', () => {
        alertBar.hidden = true;
    });
});
